import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import FormikContainer from "../../../../../components/form/FormikContainer.jsx";
import genericTranslations from "../../../../../utils/genericTranslations.js";
import {
  createMalfunctionCategory,
  fetchPublicMalfunctionsCategories,
} from "../../../thunks.js";
import MalfunctionsForm from "../MalfunctionsForm.jsx";

const messages = defineMessages({
  malfunction: {
    id: "modules.Malfunctions.components.MalfunctionDetail.malfunction",
    description: "Malfunction label.",
    defaultMessage: "Malfunction workorder",
  },
});

const { VITE_MALFUNCTIONS_API_KEY } = import.meta.env;

const OpenMalfunctionsEditor = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { identifier } = useParams();

  const [error, setError] = useState(undefined);

  useEffect(() => {
    const fetchMalfunctionsCategories = async () => {
      try {
        await dispatch(fetchPublicMalfunctionsCategories());
      } catch (err) {
        setError("Error fetching the malfunctions", err.message);
      }
    };

    fetchMalfunctionsCategories();
  }, [dispatch]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    const body = {
      key: VITE_MALFUNCTIONS_API_KEY,
      failureCode: values.category,
      vehicleNumber: identifier,
      vehicleType: "TRAIN", // Fixed as TRAIN for now
      description: values.comment,
    };

    try {
      await dispatch(createMalfunctionCategory(body));
      navigate("/email-establishment", { replace: true });
    } catch (err) {
      setError(`Er ging iets fout bij het opslaan: ${err}`);
    } finally {
      setSubmitting(false);
    }
  };

  const validate = (values) => {
    const errors = {};
    const required = ["category"];
    required.forEach((field) => {
      if (!values[field]) errors[field] = "Verplicht";
    });
    return errors;
  };

  if (error) {
    return (
      <Card>
        <Card.Body>
          <strong>
            {intl.formatMessage(genericTranslations.errorMessage)}{" "}
          </strong>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {intl.formatMessage(messages.malfunction)}{" "}
        {intl.formatMessage(genericTranslations.add).toLowerCase()}
      </Card.Header>
      <Card.Body>
        <FormikContainer
          initialValues={{}}
          onSubmit={handleSubmit}
          validate={validate}
          formComponent={MalfunctionsForm}
        />
      </Card.Body>
    </Card>
  );
};

export default OpenMalfunctionsEditor;
